import fromPairs from "lodash/fromPairs"
import formatStoredField from "shared/lib/format_stored_field"

const initialState = {
  byService: {},
}

export default function triggers(state = initialState, event) {
  switch (event.type) {
    default: {
      return state
    }

    case "TRIGGERS_LOADED": {
      const triggers = fromPairs(
        event.triggers.map(trigger => [
          trigger.module_name,
          {
            ...trigger,
            channel_module_name: event.serviceModuleName,
            fields: trigger.trigger_fields.map(triggerField => ({
              ...triggerField,
              stored_field: formatStoredField(
                "trigger",
                trigger.full_module_name,
                triggerField
              ),
            })),
          },
        ])
      )

      return {
        ...state,
        byService: {
          ...state.byService,
          [event.serviceModuleName]: triggers,
        },
      }
    }
  }
}

export const triggerQueryFields = `
  module_name
  full_module_name
  name
  description
  id
  normalized_module_name

  channel {
    id
    module_name
    normalized_module_name
  }

  ingredients {
    id
    name
    slug
    normalized_name
    example
    value_type
  }

  trigger_fields {
    id
    name
    label
    field_ui_type
    field_type
    required
    normalized_field_type
    shareable
    hideable
    can_have_default
    helper_text
  }
`
